import { gql } from "@apollo/client";

export const CREATE_OFFERLETTER = gql`
  mutation createOfferLetter($input: createOfferLetterInput) {
    createOfferLetter(input: $input) {
      Id
    }
  }
`;

export const GET_OFFERLETTER_BY_ORG = gql`
  query offerLetterByOrg($orgId: Int) {
    offerLetterByOrg(orgId: $orgId) {
      Id
      applicantId
      fullName
      address
      designation
      issueDate
      authPerson
      joinedDate
      uploadLogo
      jobId
      joinedDate
      templateDescription
      template
      jobData {
        position
      }
      authorizedSignatureDetails {
        name
        attachment
        Id
      }
      ctc
      offerStatus
      salaryTemplate
      internStartDate
      internEndDate
      internDuration
      internPaidDate
      intern
      CTCBreakdown
    }
  }
`;

export const GET_OFFERLETTER_BY_ID = gql`
  query OfferLetterById($id: Int) {
    offerLetterById(Id: $id) {
      Id
      applicantId
      fullName
      address
      designation
      issueDate
      authPerson
      joinedDate
      uploadLogo
      jobId
      joinedDate
      templateDescription
      template
      jobData {
        position
      }
      authorizedSignatureDetails {
        name
        attachment
        Id
      }
      ctc
      offerStatus
      salaryTemplate
      internStartDate
      internEndDate
      internDuration
      internPaidDate
      intern
      CTCBreakdown
    }
  }
`;

export const CREATE_EXPERIENCELETTER = gql`
  mutation createExperienceLetter($input: createExperienceLetterInput) {
    createExperienceLetter(input: $input) {
      Id
    }
  }
`;

export const GET_EXPERIENCELETTER_BY_ORG = gql`
  query experienceLetterByOrg($orgId: Int) {
    experienceLetterByOrg(orgId: $orgId) {
      Id
      orgId
      employeeName
      joiningDate
      leavingDate
      template
      templateId
      issueDate
      authorizedSignatureDetails {
        name
        attachment
        Id
      }
      userDetails {
        firstName
        lastName
        designation
        gender
      }
      duration
    }
  }
`;

export const UPDATE_OFFER_LETTER = gql`
  mutation updateOfferLetter($input: updateOfferletterInput) {
    updateOfferLetter(input: $input)
  }
`;

export const DELETE_OFFER_LETTER = gql`
  mutation DeleteOfferLetter($id: Int) {
    deleteOfferLetter(Id: $id)
  }
`;

export const UPDATE__EXPERIENCE_LETTER = gql`
  mutation updateExperienceLetter($input: updateExperienceletterInput) {
    updateExperienceLetter(input: $input)
  }
`;

export const DELETE_EXPERIENCE_LETTER = gql`
  mutation deleteExperienceLetter($Id: Int) {
    deleteExperienceLetter(Id: $Id)
  }
`;

export const GET_EXPERIENCELETTER_BY_ID = gql`
  query experienceLetterById($Id: Int) {
    experienceLetterById(Id: $Id) {
      Id
      employeeName
      joiningDate
      leavingDate
      orgId
      template
      templateId
      issueDate
      authorizedSignatureDetails {
        name
        attachment
        Id
      }
      duration
    }
  }
`;

export const UPDATE__HIKE_LETTER = gql`
  mutation updateHikeLetter($input: updateHikeletterInput) {
    updateHikeLetter(input: $input)
  }
`;

export const DELETE_HIKE_LETTER = gql`
  mutation deleteHikeLetter($Id: Int) {
    deleteHikeLetter(Id: $Id)
  }
`;

export const GET_HIKELETTER_BY_ID = gql`
  query hikeLetterById($Id: Int) {
    hikeLetterById(Id: $Id) {
      Id
      orgId
      employeeName
      designation
      currentCTC
      increment
      revisedCTC
      effectiveDate
      issueDate
      templateId
      authorizedSignature
    }
  }
`;

export const CREATE_HIKELETTER = gql`
  mutation createHikeLetter($input: createHikeLetterInput) {
    createHikeLetter(input: $input) {
      Id
    }
  }
`;

export const GET_HIKELETTER_BY_ORG = gql`
  query hikeLetterByOrg($orgId: Int) {
    hikeLetterByOrg(orgId: $orgId) {
      Id
      orgId
      employeeName
      designation
      currentCTC
      increment
      revisedCTC
      effectiveDate
      issueDate
      templateId
      authorizedSignature
      authorizedSignatureDetails {
        name
        attachment
        Id
      }
      userDetails {
        firstName
        lastName
        designation
        gender
      }
    }
  }
`;

export const GET_HIKELETTER_BY_USER_ID = gql`
  query getHikeLettersByUserId($userId: String) {
    getHikeLettersByUserId(userId: $userId) {
      Id
      orgId
      employeeName
      designation
      currentCTC
      increment
      revisedCTC
      effectiveDate
      issueDate
      templateId
      authorizedSignature
      authorizedSignatureDetails {
        name
        attachment
        Id
      }
      userDetails {
        firstName
        lastName
        designation
        gender
      }
    }
  }
`;

// 🟢 CREATE
export const CREATE_MEMBERSHIP_AGREEMENT_LETTER = gql`
  mutation createMembershipAgreementLetter(
    $input: createMembershipAgreementLetterInput
  ) {
    createMembershipAgreementLetter(input: $input) {
      Id
    }
  }
`;

// 🟡 UPDATE
export const UPDATE_MEMBERSHIP_AGREEMENT_LETTER = gql`
  mutation updateMembershipAgreementLetter(
    $input: updateMembershipAgreementLetterInput
  ) {
    updateMembershipAgreementLetter(input: $input)
  }
`;

// 🔴 DELETE
export const DELETE_MEMBERSHIP_AGREEMENT_LETTER = gql`
  mutation deleteMembershipAgreementLetter($Id: Int) {
    deleteMembershipAgreementLetter(Id: $Id)
  }
`;

// 🔍 GET BY ID
export const GET_MEMBERSHIP_AGREEMENT_LETTER_BY_ID = gql`
  query membershipAgreementLetterById($Id: Int) {
    membershipAgreementLetterById(Id: $Id) {
      Id
      orgId
      membershipId
      membershipValidityFrom
      membershipValidityTo
      issueDate
      templateId
      duration
      authorizedSignature
      membershipDetails {
        name
        location
      }
    }
  }
`;

// 🏢 GET BY ORG
export const GET_MEMBERSHIP_AGREEMENT_LETTER_BY_ORG = gql`
  query membershipAgreementLetterByOrg($orgId: Int) {
    membershipAgreementLetterByOrg(orgId: $orgId) {
      Id
      orgId
      membershipId
      membershipValidityFrom
      membershipValidityTo
      issueDate
      templateId
      duration
      authorizedSignature
      membershipDetails {
        name
        location
      }
    }
  }
`;
